<div class="error-container" aria-live="assertive">
  <div class="alert valign-children-middle" *ngIf="errorMessage">
    <div class="alert-error" aria-label="Alert.">
      <i class="icon-badgealert" aria-hidden="true"></i>
    </div>
    <div>
      <h2 *ngIf='errorFlag'>No licenses available</h2>
      <h2 *ngIf='!errorFlag'>Error!</h2>
      <p>{{ this.errorMessage }}</p>
    </div>
  </div>
</div>
<div class="row" *ngIf="userWizardModel !== null">
  <div class="col-sm-12 col-md-6 col-md-offset-3" >
    <div *ngIf="isProductAvailable">
    <div *ngIf="this.userWizardModel.source === 'product'">
      <h2>
        <h2>Selected product</h2>
      </h2>
    </div>
    <div *ngIf="this.userWizardModel.source !== 'product'">
      <h2>
        <h2>Select products</h2>
      </h2>
      <div *ngIf="this.userWizardModel.actionType === 'ASSIGN'">
        <p>The following products have licenses that are not yet assigned to users.</p>
        <ul class="bullet-list mar-bot-20">
          <li>If you select multiple products, you can only assign the licenses to one user. </li>
          <li>If you select a single product, you can assign licenses for that product to multiple users.</li>
        </ul>
      </div>
      <div *ngIf="this.userWizardModel.actionType === 'UNASSIGN'">
        <p>The following products have licenses assigned to users.</p>
        <ul class="bullet-list mar-bot-20">
          <li>If you select a single product, you can un-assign licenses for that product from multiple users.</li>
          <li>If you select multiple products, you can only un-assign licenses from one user.</li>
        </ul>
      </div>
    </div>
    <div class="row" *ngFor="let userWizardModelObject of this.userWizardProductModel.product; let i = index">
      <div class="col-sm-12 col-md-12" *ngIf="!userWizardModelObject.isHidden">
        <label [attr.for]="'specName'+i" class="checkbox">
           <input type="checkbox" id="{{'specName' + i}}"
           (click)="getProductsDetial($event.target.checked,i)" [checked]="userWizardModelObject.isChecked" [disabled]="userWizardModelObject.isDisabled">
            <i class="skin"></i>
            <span class="product-name">{{userWizardModelObject.productName}}</span>
    </label>
        <div class="user-information" *ngIf="userWizardModelObject.isChecked && userWizardModelObject.fan.length > 0">
          <div class="form-group">
            <div class="col-sm-12 col-md-8">
              <label [attr.for]="'fan'+i">Foundation account</label>
              <app-dropdown [labelId]="'fan'+i" [options]="userWizardModelObject.fan" [prePopulateValue]="userWizardModelObject.selectedFan" (selectEmit)="selectedFanDropDown($event,i)"></app-dropdown>
            </div>
          </div>
          <div class="form-group" *ngIf="userWizardModelObject.selectedFan !== 'Select' && userWizardModelObject.ctn">
            <div class="col-sm-12 col-md-8">
              <label [attr.for]="'ctn'+i">Wireless number</label>
              <app-dropdown [labelId]="'ctn'+i" [options]="userWizardModelObject.ctn" [prePopulateValue]="userWizardModelObject.selectedCtn" (selectEmit)="selectedCtnDropDown($event,i)"></app-dropdown>
            </div>
          </div>
        </div>
        <div class="user-information mar-bot-20" *ngIf="userWizardModelObject.isDisabled">
            <p class="display-column">Another administrator in your organization has already purchased this product. However, the licenses are managed
              under an account you don't have access to. To use this product, you must purchase licenses and bill them to
              an account you manage.</p>
              <a href="javascript:void(0)" (click)="redirectToBuyNow(userWizardModelObject)"> Buy now.</a>
          </div>
      </div>
    </div>
    <hr class="top-bottom" />
    </div>
    <div class="line-footer text-right">
      <button type="button" aria-label="Continue." class="btn btn-secondary btn-sm-block pull-right" [disabled]="!this.isContinueValid"
        (click)="nextStep()">Continue</button>
      <a href="javascript:void(0)" class="btn btn-link btn-sm-block" (click)="cancel()">Cancel</a>
    </div>
  </div>
</div>